const API_BASE =
  (import.meta.env.VITE_API_BASE_URL as string | undefined) ?? "http://localhost:8787";

export interface ApiError {
  status: number;
  message: string;
  body?: unknown;
}

export class ApiRequestError extends Error {
  status: number;
  body?: unknown;

  constructor(info: ApiError) {
    super(info.message);
    this.name = "ApiRequestError";
    this.status = info.status;
    this.body = info.body;
  }
}

export async function apiFetch<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(`${API_BASE}${path}`, {
    credentials: "include",
    headers: { "Content-Type": "application/json", ...init?.headers },
    ...init,
  });
  if (!res.ok) {
    const info: ApiError = { status: res.status, message: res.statusText };
    try {
      info.body = await res.json();
    } catch {
      /* response body might not be JSON; that's fine */
    }
    throw new ApiRequestError(info);
  }
  return res.json() as T;
}

// Multipart upload: must NOT set Content-Type (browser sets the multipart boundary).
export async function apiUpload<T>(path: string, formData: FormData, method = "PUT"): Promise<T> {
  const res = await fetch(`${API_BASE}${path}`, { method, credentials: "include", body: formData });
  if (!res.ok) {
    const info: ApiError = { status: res.status, message: res.statusText };
    try {
      info.body = await res.json();
    } catch {
      /* not json */
    }
    throw new ApiRequestError(info);
  }
  return res.json() as T;
}
